import { render, staticRenderFns } from "./ImgPullQuote.vue?vue&type=template&id=7c3d2e40&scoped=true&"
import script from "./ImgPullQuote.vue?vue&type=script&lang=js&"
export * from "./ImgPullQuote.vue?vue&type=script&lang=js&"
import style0 from "./ImgPullQuote.vue?vue&type=style&index=0&id=7c3d2e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3d2e40",
  null
  
)

export default component.exports